import React, { useRef, useEffect } from 'react';
import CommonModal from './Modal';
import { TAB_KEY_STATUS } from '../../../utilities/constants';

const Confirmation = props => {
  const {
    visible = false,
    title = '',
    message = '',
    confirmButtonText = 'OK',
    cancelButtonText = 'キャンセル',
    isNegative = false,
    onConfirm,
    onCancel,
    isSubmitting = false,
    disabledConfirmButton = false,
    rootClassName,
    negativeButtonClassName = 'btn--negative',
    effectiveButtonClassName = 'btn--effective',
    cancelButtonClassName = 'btn--sub',
    disabledButtonClassName = 'btn--disabled',
    isVerticalButton = false,
    multilineText = false, // 通常のダイアログは左寄せ(true) - MESSAGE_LISTの<br>を利用する場合もtrueが必須
    tabFocus = false, // trueの場合、Tabキーはダイアログ内の移動のみ可能
  } = props;

  const dialogRef = useRef(null);
  const firstFocusableElement = useRef(null);
  const lastFocusableElement = useRef(null);
  const justOpenedRef = useRef(false);
  const handleKeyDown = event => {
    if (event.key === 'Tab') {
      if (!tabFocus) {
        return;
      }

      if (
        event.shiftKey &&
        document.activeElement === firstFocusableElement.current
      ) {
        // Shift + Tabの場合の選択ロジック
        event.preventDefault();
        lastFocusableElement.current.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === lastFocusableElement.current
      ) {
        // Tabの選択ロジック
        event.preventDefault();
        firstFocusableElement.current.focus();
      }
    }
  };

  // BLDE_V2-44056 ブラウザの外をクリックしてからTabキーを押下した場合の対応
  const handleFocusIn = event => {
    if (visible && !dialogRef.current.contains(event.target) && tabFocus) {
      const dialogElement = dialogRef.current;
      const focusableElements = dialogElement.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      firstFocusableElement.current = focusableElements[0];
      lastFocusableElement.current =
        focusableElements[focusableElements.length - 1];
      firstFocusableElement.current && firstFocusableElement.current.focus();
    }
  };

  useEffect(() => {
    // 表示時、ダイアログ内で選択可能にさせる項目を探す
    if (tabFocus) {
      const dialogElement = dialogRef.current;
      if (dialogElement) {
        const focusableElements = dialogElement.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        firstFocusableElement.current = focusableElements[0];
        lastFocusableElement.current =
          focusableElements[focusableElements.length - 1];
        document.addEventListener('focusin', handleFocusIn);
        return () => {
          document.removeEventListener('focusin', handleFocusIn);
        };
      }
    }
  }, [visible]);

  useEffect(() => {
    // 表示時、ダイアログ内に強制フォーカスさせる
    if (visible && tabFocus) {
      justOpenedRef.current = true;
      firstFocusableElement.current && firstFocusableElement.current.focus();
    }
  }, [visible]);

  return (
    <React.Fragment>
      {visible && (
        <CommonModal visible={visible}>
          <div
            className={
              rootClassName
                ? `${rootClassName} dialog-md dialog--modal`
                : 'dialog-md dialog--modal'
            }
            ref={dialogRef}
            tabIndex={
              tabFocus ? TAB_KEY_STATUS.enabled : TAB_KEY_STATUS.disabled
            }
            onKeyDown={handleKeyDown}
          >
            {title !== '' && (
              <div className='dialog-md__header'>
                <span
                  className='dialog-md__title'
                  data-testid='confirmation_title'
                >
                  {title}
                </span>
              </div>
            )}
            {message !== '' && (
              <div
                className={
                  multilineText
                    ? 'dialog-md__body dialog-md__body-prewrap text-left'
                    : 'dialog-md__body text-left'
                }
                data-testid='confirmation_body'
              >
                {message}
              </div>
            )}
            <div
              className={
                isVerticalButton
                  ? 'dialog-md__footer'
                  : 'dialog-md__footer-horizontal'
              }
            >
              {isNegative ? (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={negativeButtonClassName}
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <button
                    className={cancelButtonClassName}
                    onClick={onCancel ? onCancel : undefined}
                    disabled={isSubmitting ? 'disabled' : ''}
                  >
                    {cancelButtonText}
                  </button>
                  <button
                    className={
                      disabledConfirmButton
                        ? disabledButtonClassName
                        : effectiveButtonClassName
                    }
                    onClick={onConfirm ? onConfirm : undefined}
                    disabled={
                      isSubmitting || disabledConfirmButton ? 'disabled' : ''
                    }
                  >
                    {confirmButtonText}
                  </button>
                </React.Fragment>
              )}
            </div>
          </div>
        </CommonModal>
      )}
    </React.Fragment>
  );
};

export default Confirmation;



// WEBPACK FOOTER //
// ./src/components/modals/common/Confirmation.jsx